export { generateSampleUptimeData } from './generateSampleData'
export {
  getBgStatusColor,
  getBorderStatusColor,
  getCellColor,
  getFillColor,
  getTextStatusColor,
} from './getColor'
